import { Newsroom } from "../../types/index.js";
export const Scope = {
  EXCLUDE_ARCHIVED_NEWSROOMS: {
    'newsroom.status': {
      $nin: [Newsroom.Status.ARCHIVED]
    }
  }
};